import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

const resitFlowRouteKey = {
  selectSubjects: 'select-subjects',
  confirmParticulars: 'confirm-particulars',
  reviewPay: 'review-pay',
};

/**
 * A hook to provide registration of resit flow inner route
 * @param url Current url of the page
 * @returns
 */
export const useRegisterResitRoute = (url: string) => {
  const history = useHistory();
  const [step, setStep] = useState(0);
  const [selectedSubjects, setSelectedSubjects] = useState<number[] | null>(null);

  const toStep1 = useCallback(() => {
    setStep(0);
    history.push(`${url}/${resitFlowRouteKey.selectSubjects}`);
  }, [history, url]);

  const toStep2 = useCallback(
    (subjects: number[]) => {
      setSelectedSubjects(subjects);
      setStep(1);
      history.push(`${url}/${resitFlowRouteKey.confirmParticulars}`);
    },
    [history, url]
  );

  const toStep3 = useCallback(() => {
    setStep(2);
    history.push(`${url}/${resitFlowRouteKey.reviewPay}`);
  }, [history, url]);

  return {
    step,
    selectedSubjects,
    localRouteKey: resitFlowRouteKey,
    toStep1,
    toStep2,
    toStep3,
  };
};
